import { withScopeContext } from '@mews/framework';
import OrderItemListItemTextPure from './OrderItemListItemText';

export const OrderItemListItemText = withScopeContext(OrderItemListItemTextPure);
